import { Action } from 'redux';
/**
 * Defines actions that can be performed for the
 * JWT in the store.
 */

export enum JwtActionTypes {
    SetJwt = "SET_JWT",
    ClearJwt = "CLEAR_JWT"
}

export interface SetJwt extends Action{
    type: JwtActionTypes.SetJwt;
    jwt: string;
}

export interface ClearJwt extends Action{
    type: JwtActionTypes.ClearJwt;
}